module.exports = __webpack_public_path__ + "assets/cuisine_type-0133d5.svg";